export default __webpack_public_path__ + "static/media/screen_livechat_01.5b6c0806.png";